import { api } from './authenticatedApi';

export interface AutonomySettings {
  id: string;
  name?: string;
  autonomyLevel: 'observe' | 'propose' | 'auto_patch';
  maintenanceCadence: 'weekly' | 'monthly' | 'manual';
}

export interface AutonomousActivity {
  id: string;
  kind: 'scan' | 'patch_proposed' | 'patch_approved' | 'patch_rejected';
  taskType: string | null;
  summary: string;
  scoreDelta: number | null;
  occurredAt: string;
}

export class AutonomyService {
  static async get(repositoryId: string) {
    return api.get<{ settings: AutonomySettings; activity: AutonomousActivity[] }>(
      `/repositories/${repositoryId}/autonomy`,
    );
  }

  static async update(
    repositoryId: string,
    data: { autonomyLevel?: string; maintenanceCadence?: string },
  ) {
    return api.patch<AutonomySettings>(`/repositories/${repositoryId}/autonomy`, data);
  }
}
